module.exports = {
      id: "icon-copy-usage",
      viewBox: "0 0 19.657 19.657",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-copy",
      toString: function () {
        return this.url;
      }
    }